export enum EMyWorkTab {
    IMPORT = 'IMPORT',
    SETTINGS = 'SETTINGS',
    BACKGROUND = 'BACKGROUND',
};
